import type { QualifyRunName } from "./types";

const SEPARATOR = "·";

export const qualifyRunName: QualifyRunName = ({
  text,
  runBoard,
  feedingBoard,
  boardName,
}) => {
  if (!feedingBoard || feedingBoard === runBoard) return text;
  const prefix = runBoard ? `${runBoard}${SEPARATOR}` : null;
  // A name that does not lead with its board carries no board to correct.
  if (!prefix || !text.startsWith(prefix)) return text;
  return `${boardName(feedingBoard)}${SEPARATOR}${text.slice(prefix.length)}`;
};
